import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const StyledWrapper = styled.div`
  button {
    margin-top: 30px;
    width: 161px;
  }
  @media (min-width: 992px){
      .highlight_card_image{
        min-height: 625px;
        max-height: 625px;
        object-fit:cover;
    }
  }

  @media (min-width: 320px) and (max-width: 575px) {
    .highlightText {
      display: none;
    }
    .highlight_card_image{
        height: 70vh;
        object-fit:cover;
    }
  }

  @media (max-width: 767px) {
    button {
      width: 100%;
    }
    .highlight_card_image{
        height: 70vh;
        object-fit:cover;
    }
    h3,
    p {
      text-align: left;
    }
  }
`

const featureHighlightCard2 = (props) => {
    return (
        <StyledWrapper>
            <div className="container my-5">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-7 ms-lg-n3">
                        <div className="">
                            {/* Displays Only in Medium Devices and Higher */}
                            <img
                                src={props[1]?.image}
                                alt=""
                                className="d-block highlight_card_image w-100 mx-auto mb-3"
                            />
                        </div>
                    </div>
                    <div className="offset-lg-1 col-md-5 d-flex flex-column px-md-5">
                        <h2 className="mb-3">{props[1]?.title}</h2>
                        {/* Display only in Desktop and above */}
                        <div className="d-lg-block d-md-none d-none highlightText">
                            <p>
                                {props[1]?.primaryDescription}
                            </p>
                            <p>{props[1]?.secondaryDescription}</p>
                        </div>
                        {/* Display only in medium devices */}
                        <div className="d-md-block d-lg-none d-none highlightText">
                            <p>
                                {props[1]?.primaryDescription}
                            </p>
                            <p>{props[1]?.secondaryDescription}</p>
                        </div>
                        {/* Display only in smaller devices */}
                        <p className="d-sm-block d-md-none">
                            {props[1]?.primaryDescription}
                        </p>
                        <p className="d-sm-block d-md-none">{props[1]?.secondaryDescription}    </p>

                        <Link to={props[1]?.cta.handle}>
                            <button className="btn btn-dark"> {props[1]?.cta.title}</button>
                        </Link>
                    </div>
                </div>
            </div>
        </StyledWrapper>
    )
}

export default featureHighlightCard2
